import styled from 'styled-components';
import * as colors from '../../stylesheet/Colors.style';

export const Background = styled.div`
  width: 100%;
  height: 550px;
  background-color: ${colors.colors.purple};
  position: absolute;
  padding: 0;
`;
